// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Cu7P","question":"styles_question__1-nUG","inputVisibleButton":"styles_inputVisibleButton__3TiI3","note":"styles_note__cAp5r"};